import React, { useState, useEffect } from 'react'
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { checkTokenExpiry, logout } from './utils/tokenManager';

import Sidebar from './components/Sidebar'
import Header from './components/Header'
import Dashboard from './pages/Dashboard'
import Overview from './pages/Overview'
import AddProduct from './pages/AddProduct'
import EditProduct from './pages/EditProduct'
import ProductList from './pages/ProductList'
import AddCategory from './pages/AddCategory'
import AddBanner from './pages/AddBanner'
import OrdersList from './pages/OrdersList'
import Login from './pages/Login'
import CategoryList from './pages/CategoryList'
import BannerList from './pages/BannerList'
import CustomerList from './pages/CustomerList'
import ShippingSettings from './pages/ShippingSettings'
import AddShipping from './pages/AddShipping'
import EditShipping from './pages/EditShipping'
import Settings from './pages/Settings'

// Import all SCSS files
import './styles/App.scss'
import './styles/base.scss'
import './styles/components/buttons.scss'
import './styles/components/cards.scss'
import './styles/components/forms.scss'
import './styles/components/sidebar.scss'
import './styles/components/header.scss'
import './styles/components/data-table.scss'
import './styles/pages/dashboard.scss'
import './styles/pages/analytics.scss'
import './styles/pages/overview.scss'
import './styles/pages/orders.scss'
import './styles/pages/customers.scss'
import './styles/pages/reviews.scss'
import './styles/pages/stock.scss'
import './styles/pages/products.scss'
import './styles/pages/add-template.scss'
import './styles/pages/login.scss'
import './styles/pages/list-pages.scss'
import './styles/pages/settings.scss'

function App() {
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false)
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false)
  const [isAuthenticated, setIsAuthenticated] = useState(() => {
    return localStorage.getItem('isAuthenticated') === 'true'
  })

  useEffect(() => {
    const handleStorageChange = () => {
      setIsAuthenticated(localStorage.getItem('isAuthenticated') === 'true')
    }
    
    const checkAuth = () => {
      if (isAuthenticated && !checkTokenExpiry()) {
        logout();
      }
    };
    
    checkAuth();
    const interval = setInterval(checkAuth, 60000);
    
    window.addEventListener('storage', handleStorageChange)
    return () => {
      window.removeEventListener('storage', handleStorageChange)
      clearInterval(interval)
    }
  }, [isAuthenticated])

  if (!isAuthenticated) {
    return (
      <Router>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="*" element={<Navigate to="/login" replace />} />
        </Routes>
      </Router>
    )
  }

  return (
    <Router>
      <div className="app">
        <Sidebar collapsed={sidebarCollapsed} setCollapsed={setSidebarCollapsed} mobileOpen={mobileMenuOpen} setMobileOpen={setMobileMenuOpen} />
        <div className={`main-content ${sidebarCollapsed ? 'sidebar-collapsed' : ''}`}>
          <Header onMenuClick={() => setMobileMenuOpen(!mobileMenuOpen)} />
          <div className="content-area">
            <Routes>
              <Route path="/login" element={<Navigate to="/dashboard" replace />} />
              <Route path="/" element={<Dashboard />} />
              <Route path="/dashboard" element={<Dashboard />} />
              <Route path="/overview" element={<Overview />} />
              <Route path="/add-product" element={<AddProduct />} />
              <Route path="/edit-product/:id" element={<EditProduct />} />
              <Route path="/product-list" element={<ProductList />} />
              <Route path="/add-category" element={<AddCategory />} />
              <Route path="/add-banner" element={<AddBanner />} />
              <Route path="/orders" element={<OrdersList />} />
              <Route path="/category-list" element={<CategoryList />} />
              <Route path="/banner-list" element={<BannerList />} />
              <Route path="/customers" element={<CustomerList />} />
              <Route path="/shipping-settings" element={<ShippingSettings />} />
              <Route path="/add-shipping" element={<AddShipping />} />
              <Route path="/edit-shipping/:id" element={<EditShipping />} />
              <Route path="/settings" element={<Settings />} />
            </Routes>
          </div>
        </div>
      </div>
      <ToastContainer
        position="top-right"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
    </Router>
  )
}

export default App
